import { IconClipboardList } from '@tabler/icons-react';
import { ThemeIcon } from '@zorro/design-system/v2/ThemeIcon';
import { Group, Stack, Text } from '@zorro/web/design-system';

import { EmployeeActivityLogs } from './EmployeeActivityLogs';

type Props = {
  onboardingPeriodId: string;
  isDon: boolean;
};

export const EmployeeActivityLogTab = ({
  onboardingPeriodId,
  isDon,
}: Props) => {
  return (
    <Stack gap="xs" mt="xs">
      <Group gap="xs" align="center">
        <ThemeIcon size="32" color="indigo">
          <IconClipboardList size={16} />
        </ThemeIcon>
        <Text size="md" fw={600}>
          Enrollment activity
        </Text>
      </Group>

      <EmployeeActivityLogs
        onboardingPeriodId={onboardingPeriodId}
        isDon={isDon}
      />
    </Stack>
  );
};
